import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { LoginService } from '../services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { api } from '../URL/api-url';
import { HttpClient } from '@angular/common/http';
import Cookies from 'js-cookie'
import { ApiCommonService } from '../services/api-common.service';
import { CONSTANTS } from '../constants';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
})
export class SigninComponent {
  changepasswordform: any = new FormGroup({
    newpassword: new FormControl(''),
    confirmpassword: new FormControl(''),
  });
  token: any = ''
  userloggedin: boolean = false;
  logo =
    'https://testadminapi.groupbenefitz.aitestpro.com/api/ap/app/resources/images/broker/gb.jpg';
  loginForm: FormGroup = new FormGroup({
    username: new FormControl(),
    password: new FormControl(),
  });
  username: any;
  submitted: any = false;
  credentials: any;
  activationEmail: any;
  studentusername: any;
  studentpassword: any;
  selectedLanguage: any;
  forgotform: FormGroup = new FormGroup({
    email: new FormControl(''),
  });
  activation: FormGroup = new FormGroup({
    activationcode: new FormControl(''),
  });
  OverviewComponent = false;
  customerId: any;
  formConfiguration: any;
  lang: any;
  parentlogo: any;
  public showPassword!: boolean;
  public showPasswordOnPress!: boolean;
  copyright: any;
  env: any = api

  lang2 = {
    Reset_Password: 'Reset Password',
    Enter_New_Password: 'Enter New Password',
    Confirm_Password: 'Confirm Password',
    Please_enter_password: 'Please enter new password.',
    Password_must_be_at_least_8_characters: 'Password must be at least 8 characters.',
    Password_must_not_exceed_40_characters: 'Password must not exceed 40 characters.',
    Please_enter_confirm_password: 'Please enter confirm password.',
    Passwords_did_not_match: 'Passwords did not match.',
    Submit: 'Submit'
  };
  constants: any = CONSTANTS;
  showLoginPage: any = false;
  subHeadingText: any = '';
  isViking: boolean = false;
  isNhlaa: boolean = false;
  currClient:any = ''

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private apiCommonService: ApiCommonService,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      sessionStorage.setItem("timeStamp", new Date().getTime().toString());
    }, 1000)

    this.getLanguageTokens()
    this.token = this.route.snapshot.queryParams['token'];
    this.initForm();
    this.copyright = new Date().getFullYear()




    //   Swal.fire({title:'Info',text:"Something went wrong please try again later"})


    this.route.queryParams.subscribe((params) => {

      if (params) {
        if (params['username'] != null) {
          this.studentusername = params['username'].replace(' ', '+');

          this.studentpassword = params['pass'];
        }
      }
    });


    if (this.studentusername) {
      this.loginService.checkUserLoggedInForFirstTime(this.studentusername).subscribe(
        (response: any) => {
          if (response['statusCode'] == 200 || response['status'] == 200) {
            if (response['firstTimeUser']) {
              $("#changepassword").show()
            }

            $('#forgotpassword').hide();
            this.forgotform.reset();
          }
        },
        (error) => {
          Swal.fire({ title: 'Info', text: error.error.error.message });
        }
      );
    }


    sessionStorage.clear();
    let username = this.route.snapshot.queryParams['username'];
    if(username){
      sessionStorage.setItem("username", username)
    }
    setTimeout(()=>{
      sessionStorage.setItem('pageName','Login');
    }, 100);
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(40),
        ],
      ],
    });

    this.forgotform = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?!\\s)[_A-Za-z0-9._%+-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
          ),
        ],
      ],
    });

    this.activation = this.formBuilder.group({
      activationcode: ['', [Validators.required]],
    });

  }

  get formControls(): any {
    return this.loginForm.controls;
  }

  get forgot(): { [key: string]: AbstractControl } {
    return this.forgotform.controls;
  }

  get activate(): { [key: string]: AbstractControl } {
    return this.activation.controls;
  }


  submit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    } else {
      this.credentials = this.loginForm.value
      let inputData = {
        "username": this.loginForm.value.username.trim(),
        "password": this.loginForm.value.password.trim(),
      }

      console.log(inputData)
      this.activationEmail = {
        username: this.credentials.username,
      };

      console.log('Credentials: ' + JSON.stringify(inputData));



      // call signin api three times for safety if the api get failed
      this.attemptLogin(inputData, 1)
    }
  }

  attemptLogin(inputData: any, attempt: number = 1): void {
    let currentTimeStamp = new Date().getTime().toString();
    try {
      console.log('Login Attempt #' + attempt);
      console.log('Credentials: ' + JSON.stringify(inputData));

      this.loginService.login(inputData).subscribe({
        next: (data: any) => {
          const statusCode = data?.status || data?.statusCode;

          switch (statusCode) {
            case 200:
              try {
                sessionStorage.setItem('login', 'true');
                sessionStorage.setItem('loginTime', data?.data?.lastLogin || '');
                sessionStorage.setItem('accessToken', data?.token || '');
                sessionStorage.setItem('customerId', data?.data?.customerId || '');
                sessionStorage.setItem('customerName', data?.data?.userName || '');
                sessionStorage.setItem('coproratelogo', data?.data?.corporateLogo || '');

                if (Array.isArray(data?.settings) && data.settings.length > 0) {
                  sessionStorage.setItem("fileSize", data.settings[0]?.settingsValue || '');
                }

                this.customerId = data?.data?.customerId || '';
                 if(this.currClient){
                    this.router.navigate([`${this.currClient}/home`]);
                  }else{
                    this.router.navigate(['home']);
                  }

                // add activity of successful login
                let activity: any = {};
                activity.customerId = data?.data?.customerId;
                activity.role = data?.data?.role;
                activity.portal = CONSTANTS.PORTAL;
                activity.url = api.url + this.loginService.loginEndpoint;
                activity.action = 'Logging into Member/Customer portal';
                activity.requestMethod = 'POST';
                activity.requestBody = JSON.stringify({ username: inputData.username });
                activity.status = CONSTANTS.SUCCESS;
                activity.response = JSON.stringify(data);
                activity.responseSummary = 'Successfully logged into Member/Customer portal';

                this.apiCommonService.submitActivitytLog(activity);
                this.apiCommonService.getAndSubmitCookies('Login', true, { username: inputData.username });

              } catch (storageError) {
                console.error('Session storage error: ' + JSON.stringify(storageError));
                Swal.fire({ title: 'Error', text: 'Please enter valid credentials' });

                Cookies.set('Login_Session_Storage_Error_' + currentTimeStamp, 'Session storage error: ' + JSON.stringify(storageError));

                // create object for report log
                let obj = {
                  customerDetails: JSON.stringify({ username: inputData.username }),
                  browser: '',
                  systemDetails: {},
                  logs: `Session storage error ${currentTimeStamp}:` + JSON.stringify(storageError),
                  sessionDetails: '{}'
                };
                this.apiCommonService.submitReportLog(obj);
              }
              break;

            case 206:
              $('#activationlink').show();
              break;

            case 400:
              if (attempt < 3) {
                console.error(`Login attempt ${attempt} failed, retrying...`);
                Cookies.set('Login_Error_Attempt_' + currentTimeStamp, `Login attempt ${attempt} failed, retrying...`);

                // create object for report log
                let obj = {
                  customerDetails: JSON.stringify({ username: inputData.username }),
                  browser: '',
                  systemDetails: {},
                  logs: `Login attempt ${attempt} failed, retrying... ${currentTimeStamp}`,
                  sessionDetails: '{}'
                };
                this.apiCommonService.submitReportLog(obj);

                this.attemptLogin(inputData, attempt + 1);
              } else {
                Swal.fire({ title: 'Error', text: data?.message || 'Please enter valid credentials' });
              }
              break;

            default:
              Swal.fire({ title: 'Error', text: data?.message || 'Please enter valid credentials' });
              console.error('Unknown response: ' + JSON.stringify(data));

              Cookies.set('Login_Unknown_Error_' + currentTimeStamp, 'Unknown response: ' + JSON.stringify(data));

              // create object for report log
              let obj = {
                customerDetails: JSON.stringify({ username: inputData.username }),
                browser: '',
                systemDetails: {},
                logs: `Unknown response ${currentTimeStamp}: ` + JSON.stringify(data),
                sessionDetails: '{}'
              };
              this.apiCommonService.submitReportLog(obj);
              break;
          }
        },

        error: (error) => {
          console.error(`Login API error on attempt ${attempt}: ` + JSON.stringify(error));
          Cookies.set('Login_Api_Error_' + currentTimeStamp, `Login API error on attempt ${attempt}: ` + JSON.stringify(error));

          // create object for report log
          let obj = {
            customerDetails: JSON.stringify({ username: inputData.username }),
            browser: '',
            systemDetails: {},
            logs: `Login API error on attempt ${attempt} ${currentTimeStamp}: ` + JSON.stringify(error),
            sessionDetails: '{}'
          };
          this.apiCommonService.submitReportLog(obj);

          if (attempt < 3) {
            setTimeout(() => {
              this.attemptLogin(inputData, attempt + 1);
            }, 200);
          } else {
            const errorMessage = error?.error?.message || error?.message || 'Please enter valid credentials';
            Swal.fire({ title: 'Error', text: errorMessage });
          }
        }
      });
    } catch (unexpectedError) {
      console.error('Unexpected error in attemptLogin: ' + JSON.stringify(unexpectedError));
      Cookies.set('Login_Unexpected_Error_' + currentTimeStamp, 'Unexpected error in attemptLogin: ' + JSON.stringify(unexpectedError));

      // create object for report log
      let obj = {
        customerDetails: JSON.stringify({ username: inputData.username }),
        browser: '',
        systemDetails: {},
        logs: `Unexpected error in attemptLogin ${currentTimeStamp}: ` + JSON.stringify(unexpectedError),
        sessionDetails: '{}'
      };
      this.apiCommonService.submitReportLog(obj);

      Swal.fire({ title: 'Error', text: 'Please enter valid credentials' });
    }
  }


  submit_v2() {
    let inputData = {
      "username": this.studentusername,
      "password": this.changepasswordform.get('newpassword')?.value
    }

    console.log(inputData)

    console.log('Credentials: ' + JSON.stringify(inputData));
    this.loginService.login(inputData).subscribe(
      (data: any) => {
        if (data['status'] == 200 || data['statusCode'] == 200) {
          sessionStorage.setItem('login', 'true');
          sessionStorage.setItem('loginTime', data.data.lastLogin);
          sessionStorage.setItem('accessToken', data.token);
          sessionStorage.setItem('customerId', data.data.customerId);
          sessionStorage.setItem('customerName', data.data.userName);
          sessionStorage.setItem('coproratelogo', data.data.corporateLogo);
          if (data && data?.settings && data?.settings?.length > 0) {
            sessionStorage.setItem("fileSize", data?.settings[0]?.settingsValue);
          }

          this.customerId = data.data.customerId;
           if(this.currClient){
            this.router.navigate([`${this.currClient}/home`]);
          }else{
            this.router.navigate(['home']);
          }
        } else if (data['status'] == 206 || data['statusCode'] == 206) {
          $('#activationlink').show();
        }
      },
      (error) => {
        Swal.fire({ title: 'Info', text: error.error.message });
      }
    );
  }

  forgotPassword() {
    this.forgotform.reset();
    $('#forgotpassword').show();
  }






  initForm(): void {
    this.changepasswordform = this.formBuilder.group({
      newpassword: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(40)
      ]],
      confirmpassword: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(40),
        this.passwordMatchValidator
      ]]
    });
  }

  passwordMatchValidator(control: any) {
    const newpassword = control?.parent?.get('newpassword')?.value;
    if (newpassword && control.value !== newpassword) {
      return { confirmedValidator: true };
    }
    return null;
  }
  public getLanguageTokens() {
    let body = {
      "project": "Member Portal",
      "url": "Login"
    }
    this.http
      .post(api.lang + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          console.log(response)
          this.lang = {};
          this.selectedLanguage = "English"
          for (let token of response.strings) {
            this.lang[token.key] = token[this.selectedLanguage];
          }

          console.log(this.lang)
          this.subHeadingText = `${this.lang?.Health} | ${this.lang?.Dental} | ${this.lang?.Wellness}`;
          this.showLoginPage = true;
          // here grab if viking is in url
          const client:any = this.route.snapshot.paramMap.get('client');
          if(client){
            this.currClient = client
            sessionStorage.setItem("currClient", client)
            this.isViking = client === 'viking';
            this.isNhlaa = client === 'nhlaa';
          }
        })


  }

  async getIPAddress() {
    let ipAddress = 'NA';

    try {
      const response = await fetch('https://jsonip.com', { mode: 'cors' });
      const data = await response.json();
      ipAddress = data.ip;
    } catch (error) {
      try {
        const fallbackResponse = await fetch('https://api.groupbenefitz.ca/api/admin/app2');
        const fallbackData = await fallbackResponse.json();
        ipAddress = fallbackData?.data?.ip || 'NA';  // Use fallback ip if available

        // Check if IP is a local address
        if (ipAddress?.includes('127')) {
          ipAddress = 'NA';
        }
      } catch (err) {
        console.log('Error with fallback API:', err);
        ipAddress = 'NA';
      }
    }

    return ipAddress;
  }

  async SubmitChangePassword() {
    if (this.changepasswordform.valid) {
      const newpassword = this.changepasswordform.get('newpassword')?.value;
      const obj = {
        token: this.token,
        newpassword: newpassword,
        // ipAddress: await this.getIPAddress()
        ipAddress: sessionStorage.getItem('ipaddress') ?? 'NA'
      }
      console.log({ obj })
      this.http.post(api.url + '/member/reset-password', obj).subscribe((response: any) => {
        if (response.status == 200) {
          Swal.fire({
            allowOutsideClick: false,
            title: 'Info',
            text: response.message
          }).then((result) => {
            if (result.isConfirmed) {
              const modalElement = document.getElementById('changepassword') as HTMLElement;
              if (modalElement) {
                modalElement.classList.remove('show');
                modalElement.setAttribute('aria-hidden', 'true');
                modalElement.style.display = 'none';
              }
              this.submit_v2();
            }
          });

        }
        else {
          Swal.fire({ allowOutsideClick: false, title: 'Info', text: response.message })
        }
      }, (error) => {
        Swal.fire({ allowOutsideClick: false, title: 'Info', text: error.message })
      })
    }
  }

}
